import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PapelUsuario } from '../models/auth.model';
import { AuthService } from '../services/auth.service';

/** Libera a rota só ao papel informado; caso contrário redireciona a /home. A barreira real é o backend. */
export function roleGuard(papelNecessario: PapelUsuario): CanActivateFn {
  return () => {
    const auth = inject(AuthService);
    return auth.papel() === papelNecessario ? true : inject(Router).createUrlTree(['/home']);
  };
}
